wrapFlags